const store = {
    namespaced: true,
    state() {
        return {
            product: null,
            options: [],
            companies: [],
            selectedCredit: {},
            selectedCreditCompany: {},
            showModal: false,
            showModalSuccess: false,
            creditData: null,
        };
    },
    getters: {
        getCreditOptions(state) {
            return state.options.filter(item => item.credit_company.id === state.selectedCreditCompany.id);
        },
        getCreditCompanies(state) {
            return state.companies;
        },
        getShowModal(state) {
            return state.showModal;
        },
        getShowModalSuccess(state) {
            return state.showModalSuccess;
        },
        getSelectedCredit(state) {
            return state.selectedCredit;
        },
        getSelectedCreditCompany(state) {
            return state.selectedCreditCompany;
        },
        getCreditProduct(state) {
            return state.product;
        },
        creditData: state => state.creditData,
    },
    mutations: {
        setShowModal(state, value) {
            state.showModal = value;
        },
        setShowModalSuccess(state, value) {
            state.showModalSuccess = value;
        },
        setCreditProduct(state, product) {
            state.product = product;
        },
        setSelectedCredit(state, credit) {
            state.selectedCredit = credit;
        },
        setSelectedCreditCompany(state, company) {
            state.selectedCreditCompany = company;
        },
        setCreditOptions(state, options) {
            state.options = options;
        },
        setCreditCompanies(state, companies) {
            state.companies = companies;
        },
        SET_CREDIT_DATA: (state, data) => (state.creditData = data),
    },
    actions: {
        fetchCreditData: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/settings/credit_page`,
                });
                commit('SET_CREDIT_DATA', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
    },
};

export default store;
